function ErrorPage(): JSX.Element {
  return (
    <div className="grid">
      <div className="col text-center m-8">
        <h2>Opps!</h2>
        <h3>Página no encontrada</h3>
      </div>
    </div>
  );
}

export default ErrorPage;
